import { render, staticRenderFns } from "./comment-obtenir-et-utiliser-vos-avis-clients.vue?vue&type=template&id=17292c2c&"
import script from "./comment-obtenir-et-utiliser-vos-avis-clients.vue?vue&type=script&lang=js&"
export * from "./comment-obtenir-et-utiliser-vos-avis-clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports